import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@pwaPortal/app.component';
import { createAppConfig } from '@pwaPortal/app.config';
import { IPwaConfig } from '@sharedLib/models/interfaces/IPwaConfig';
import { environment } from './environments/environment';

const setAppInfo = (config: IPwaConfig) => {
  try {
    document.title = config.title || '';
  } catch (e) {}
};

Promise.all([
  fetch(environment.config_path).then((res) => res.json()),
  fetch(environment.new_config_path).then((res) => res.json()),
])
  .then(async ([config, newConfig]) => {
    environment.app_config = config;
    environment.new_config = newConfig;
    if (environment.production) {
      enableProdMode();
    }

    setAppInfo(config);
    const mergedConfig = createAppConfig(config, newConfig);
    bootstrapApplication(AppComponent, mergedConfig).catch((err) => console.error(err));
  })
  .catch((err) => {
    console.error('Configuration load error:', err);
  });
